app.controller("AdminLayoutController", [
    "$scope", "AdminLayoutService", "Socket",
    function ($scope, AdminLayoutService, Socket) {
        $scope.counts = {
            syllabus: 1
        };

        var socket = new Socket("/administration");

        socket.on('counts', function (counts) {
            $scope.counts.syllabus = counts.syllabus;
        });

        AdminLayoutService.counts().then(function (data) {
            $scope.counts = data;
        })
    }
]);
